var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsChild2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/AWS Child@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/AWS-Child",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("text", {
    id: "CHILD",
    mask: "url(#mask-2)",
    fontFamily: "IBMPlexSans-Medium, IBM Plex Sans",
    fontSize: 8,
    fontWeight: 400,
    fill: "#232F3E"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.32,
    y: 30
  }, "CHILD")), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.3796, 5.9996)",
    id: "amazon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62274617,4.08437538 C7.62274617,2.85625076 7.7811903,1.921875 6.54105604,1.92500019 C6.54105604,1.92500019 5.38623825,1.92500019 4.88957501,3.47187519 L2.65002035,3.25937462 C2.65002035,1.71875 4.0729754,0 6.75434696,0 C9.42962459,0 10.1761428,1.78125 10.1761428,2.57187462 L10.1761428,7.16874981 C10.1761428,8.02812481 11.1603277,8.81875038 11.1603277,8.81875038 L9.42962459,10.5687504 C9.12797048,10.2781258 8.24738387,9.42500114 8.04932801,9.10625076 C6.67207817,11.3187504 2.4580589,11.1781254 2.4580589,7.75625038 C2.4580589,4.56875038 6.13885087,4.140625 7.62274617,4.08437538 Z M7.62274617,5.52812529 C6.59590284,5.56250048 5.0571612,5.85937548 5.0571612,7.33437538 C5.0571612,8.921875 7.62274617,9.296875 7.62274617,6.796875 L7.62274617,5.52812529 Z",
    id: "Shape",
    fill: "#232F3E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.248973904,10.5843754 C2.48243463,11.9750004 5.97126468,14.265625 11.5990983,11.53125 C11.8276243,11.4156246 12.0043507,11.59375 11.766684,11.90625 C11.5320637,12.21875 9.63377485,14 6.44964611,14 C3.26551738,14 0.827906401,11.765625 0.0813881811,10.84375 C-0.125808806,10.6031246 0.111858313,10.4906254 0.248973904,10.5843754 Z M13.1774508,10.6281261 C13.2901906,10.7875013 13.1774508,11.4750013 12.9793949,11.9750013 C12.7813391,12.46875 12.4918728,12.8125 12.3334277,12.9437504 C12.165842,13.0843754 12.0439615,13.0281258 12.1353719,12.8250008 C12.2267823,12.6218758 12.7234451,11.3718758 12.5223429,11.1062508 C12.3242871,10.8468761 11.3949481,10.9718761 11.0597766,11.0062504 C10.7306996,11.0375004 10.6636649,11.0687504 10.6331948,10.9968758 C10.5631139,10.8187504 11.294397,10.5125008 11.7758247,10.4500008 C12.2542061,10.3937511 13.0251001,10.4250011 13.1774508,10.6281261 Z",
    id: "Path-2",
    fill: "#FF9900",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsChild2X);
export default __webpack_public_path__ + "static/media/AWS Child@2x.0b40bc9490690058c232a43afbd9e718.svg";
export { ForwardRef as ReactComponent };